export default "__VITE_ASSET__31eb7477__"